import { Col, Grid, Toggle } from 'rsuite';
import { useState } from 'react';
import { useCustomTheme } from '../../../hooks/useCustomTheme';
import { StyledRow, ContainerSize, ContainerChecked } from './styles';
import { TamanhoPizza } from '../../../components/TamanhoPizza';

const tableTitles = [
  ['Descrição', 8],
  ['', 1],
  ['Neste grupo', 4],
  ['Qtd. Sabores', 4],
  ['Qtd. Pedaços', 4],
  ['Status', 3],
];

export function TamanhosPizza({
  idGrupo,
  tamanhos,
  handleSetTamanhos,
  setSelectedsSizes,
  selectedsSizes,
  selecteds,
  setSelecteds,
}) {
  const [actives, setActives] = useState(true);
  const { theme } = useCustomTheme();

  return (
    <ContainerSize hasTamanhos={tamanhos.length > 0}>
      <ContainerChecked>
        <Toggle
          size="lg"
          checkedChildren="Ver Inativos"
          unCheckedChildren="Ver Ativos"
          defaultChecked
          onChange={() => setActives(!actives)}
        />
      </ContainerChecked>
      <Grid style={{ marginTop: 4, width: '100%' }}>
        <StyledRow>
          {tableTitles.map(([_description, size]) => (
            <Col
              xs={size}
              style={{
                color: theme.colors.text,
              }}
            >
              {_description}
            </Col>
          ))}
        </StyledRow>
        {tamanhos
          .filter((x) => x.Ativo === actives)
          .map((item, index) => (
            <TamanhoPizza
              key={item.Id}
              item={item}
              handleSetTamanhos={handleSetTamanhos}
              tamanhos={tamanhos}
              setSelecteds={setSelecteds}
              selecteds={selecteds}
              setSelectedsSizes={setSelectedsSizes}
              selectedsSizes={selectedsSizes}
              index={index}
              idGrupo={idGrupo}
            />
          ))}
      </Grid>
    </ContainerSize>
  );
}
